import React from 'react';
import styled from 'styled-components';
import usePMReport from './usePMReport';
import { Flex, Padding, WhiteSection } from 'components/base/layout-components';
import { PerformanceTopBar } from '../../PerformanceTopBar/PerformanceTopBar';
import Table from 'components/base/Table';
import EmptyData from 'components/EmptyData';
import {
  InvestmentPerTypePieSection,
  InvestmentPerIssueTypeOverTimeSection,
  PMReportSkeleton
} from './sections';
import Text from 'components/base/Text';
import withErrorBoundary from 'components/HOC/ErrorBoundryHOC';
import { StyledContainer } from './PMReport.style';
import useSidebarState from 'components/Sidebar/hooks/useSidebarState';

const Scroll = styled.div`
  padding-top: 4.8rem;
  ${({ width }) => `width: ${width};`}
  overflow-y: hidden;
  overflow-x: auto;
`;

const PMReport = props => {
  const {
    iterations,
    pieData,
    tableConfig,
    numOfTypes,
    numOfMore,
    moreTotalPercents,
    convertedMoreTotalDays,
    chartConfig,
    tableData,
    chartBarsDef,
    loaded,
    createFilters
  } = usePMReport(props);
  const { pmReportScrollWidth } = useSidebarState();

  const { hidePie, graphTitle, customLineTootip } = props.service;

  const innerText = (
    <Flex align='center' direction='column'>
      <Text size='x-x-x-large' weight='300' align='center'>
        %
      </Text>
      <Text align='center' size='medium'>
        Investment
        <br />
        per type
      </Text>
    </Flex>
  );

  return (
    <WhiteSection t='1rem' b='1rem' height='100%'>
      <PerformanceTopBar reportName={props.reportName}>
        {createFilters()}
      </PerformanceTopBar>

      {loaded && iterations.length && chartBarsDef.length ? (
        <StyledContainer padding='big' t='large'>
          {!hidePie && (
            <InvestmentPerTypePieSection
              pieData={pieData}
              innerText={innerText}
              tableConfig={tableConfig}
              numOfTypes={numOfTypes}
              numOfMore={numOfMore}
              moreTotalPercents={moreTotalPercents}
              convertedMoreTotalDays={convertedMoreTotalDays}
            />
          )}
          <Padding t='large'>
            <InvestmentPerIssueTypeOverTimeSection
              title={graphTitle}
              slicedIterations={iterations}
              chartConfig={chartConfig}
              customLineTootip={customLineTootip}
            />
          </Padding>
          <Scroll width={pmReportScrollWidth}>
            <Table columns={tableConfig} data={tableData} />
          </Scroll>
        </StyledContainer>
      ) : loaded ? (
        <EmptyData
          title='No issues were found'
          info='Try refining your search or selecting a more active board'
        />
      ) : (
        <PMReportSkeleton showPie={!hidePie} />
      )}
    </WhiteSection>
  );
};

export default withErrorBoundary(PMReport, 'Project Management');
